import Filter, {FilterValueOptions} from './filter';
import {FilterUtils} from 'src/js/lib/filtering';
import {FILTER_TYPE_NUMBER_RANGE} from 'src/js/lib/filtering/filters_definitions_constants';

class NumberRangeFilter extends Filter {
  constructor(filterData) {
    super(filterData);
    this.type = filterData.type || FILTER_TYPE_NUMBER_RANGE;
    if (filterData.value != null) {
      let fromValue = '*';
      let toValue = '*';
      if (filterData && filterData.value) {
        fromValue =
          filterData.value.from || filterData.value[0] || '0' || fromValue;
        toValue = filterData.value.to || filterData.value[1] || '0' || toValue;
      }
      this.value = {from: fromValue, to: toValue};
    }
  }

  static fromString(serializedFilter) {
    if (serializedFilter.endsWith(':*')) {
      return new NumberRangeFilter({
        property: serializedFilter.slice(0, -2),
        value: null,
      });
    }
    const {rangeFrom, rangeTo, property} =
      FilterUtils.getRangeFromString(serializedFilter);
    return new NumberRangeFilter({
      property,
      value: {from: rangeFrom, to: rangeTo},
    });
  }

  static fromSchema(schemaNode) {
    return new NumberRangeFilter({property: schemaNode.getName()});
  }

  clone() {
    return new NumberRangeFilter({
      type: this.type,
      property: this.property,
      value: {...this.value},
      id: this.id,
    });
  }

  getValue() {
    return [parseFloat(this.value.from), parseFloat(this.value.to)];
  }

  getValueToString(options?: FilterValueOptions) {
    if (this.value != null) {
      if (options?.rangeProperty === 'START') {
        return `${this.value.from}`;
      }
      if (options?.rangeProperty === 'END') {
        return `${this.value.to}`;
      }
      return `'${this.value.from}' TO '${this.value.to}'`;
    }
    return undefined;
  }

  getRangeProperties(filterSchema) {
    const node = filterSchema
      ? filterSchema.getFilterByName(this.property)
      : undefined;
    return node?.getRangeProperties();
  }

  toString() {
    if (this.value != null) {
      return `${this.property}:'${this.value.from}' TO '${this.value.to}'`;
    }
    return `${this.property}:*`;
  }

  toComponentString(filterSchema, translateService) {
    const node = filterSchema.getFilterByName(this.property);
    const label = translateService
      ? translateService.formatMessage({id: node.getLabel()})
      : node.getLabel();
    return `${label}: ${this.value.from} - ${this.value.to}`;
  }
}

export default NumberRangeFilter;
